import { render, staticRenderFns } from "./anchorReviewDetail.vue?vue&type=template&id=71a7e124&scoped=true"
import script from "./anchorReviewDetail.vue?vue&type=script&lang=js"
export * from "./anchorReviewDetail.vue?vue&type=script&lang=js"
import style0 from "./anchorReviewDetail.vue?vue&type=style&index=0&id=71a7e124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a7e124",
  null
  
)

export default component.exports